import { motion } from "framer-motion";
import Navbar from "./Navbar";

const Hero = () => {
  const martianChat = "/martian-chat.png";
  const contacts = "/contacts.png";

  return (
    <div className="relative w-full overflow-hidden">
      {/* Background Gradient with Rounded Bottom Corners */}
      <div className="absolute inset-x-0 top-0 z-0 h-[780px] sm:h-[1000px] md:h-[1160px] lg:h-[1280px] xl:h-[1380px] rounded-bl-[36px] rounded-br-[36px] sm:rounded-bl-[56px] sm:rounded-br-[56px] md:rounded-bl-[80px] md:rounded-br-[80px] overflow-hidden">
        <svg
          className="w-full h-full object-cover"
          viewBox="0 0 1920 1400"
          fill="none"
          preserveAspectRatio="xMidYMid slice"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0H1920V1000C1920 1100 1851.46 1200 1760.63 1220L200.629 1380C93.7531 1395 0 1312 0 1204V0Z"
            fill="url(#paint0_linear_24_602)"
          />
          <defs>
            <linearGradient
              id="paint0_linear_24_602"
              x1="960"
              y1="0"
              x2="960"
              y2="1400"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#FF464B" />
              <stop offset="1" stopColor="#F87B0F" />
            </linearGradient>
          </defs>
        </svg>
      </div>

      {/* Main Content Container */}
      <div className="w-full max-w-[1598px] mx-auto">
        <Navbar />

        {/* Hero Content */}
        <div className="max-w-[1500px] mx-auto px-4 pt-2 sm:pt-6 md:pt-8 lg:pt-10 pb-8 sm:pb-24 md:pb-28 lg:pb-36 flex flex-col items-center text-center">
          {/* Animated Icons and Main Heading */}
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: { opacity: 0, y: 30 },
              visible: {
                opacity: 1,
                y: 0,
                transition: {
                  staggerChildren: 0.2,
                  duration: 0.8,
                  ease: "easeOut",
                },
              },
            }}
          >
            {/* Top Floating Icons - Hidden on mobile */}
            <div className="hidden md:flex items-center justify-between max-w-[900px] mx-auto">
              {/* Left Floating Icon */}
              <motion.div
                animate={{
                  y: [10, -25, 0],
                  rotate: [0, 1, 0],
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-10 h-10 md:w-16 md:h-16"
                  viewBox="0 0 56 56"
                  fill="none"
                >
                  <rect
                    x="11.7967"
                    width="45.5787"
                    height="45.5787"
                    rx="5.83643"
                    transform="rotate(15 11.7967 0)"
                    fill="#FF8176"
                  />
                  <path
                    d="M21.3699 22.8015L27.4838 19.617C28.5987 19.037 29.8704 20.0577 29.5454 21.2708L28.9001 23.6789C37.9635 26.1075 33.5802 36.8888 33.5802 36.8888C33.5802 36.8888 32.6596 29.1697 27.7793 27.862L27.1342 30.2694C26.8092 31.4825 25.1967 31.7304 24.5224 30.6718L20.8199 24.857C20.7125 24.6882 20.6413 24.4989 20.6109 24.3012C20.5805 24.1034 20.5916 23.9015 20.6433 23.7082C20.6951 23.515 20.7865 23.3346 20.9117 23.1785C21.0369 23.0225 21.1932 22.8941 21.3706 22.8017"
                    stroke="white"
                    strokeWidth="1.16729"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </motion.div>

              {/* Right Floating Icon */}
              <motion.div
                animate={{
                  y: [10, 25, 0],
                  rotate: [0, -15, 0],
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="relative top-5"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-16 h-16 md:w-[64px] md:h-[64px]"
                  viewBox="0 0 90 90"
                  fill="none"
                >
                  <rect
                    x="8.76435"
                    y="61.8621"
                    width="56.3846"
                    height="56.3846"
                    rx="5.76554"
                    transform="rotate(-70.3399 8.76435 61.8621)"
                    fill="#FF8436"
                  />
                  <path
                    d="M50.3472 34.7322C50.1619 34.5133 49.9216 34.3476 49.6511 34.2523C49.3805 34.1571 49.0895 34.1356 48.8078 34.1901L37.7695 36.3267C37.493 36.3806 37.2355 36.506 37.0224 36.6903C36.8094 36.8747 36.6483 37.1115 36.5552 37.3774C36.4621 37.6433 36.4402 37.9289 36.4917 38.2058C36.5432 38.4828 36.6662 38.7415 36.8486 38.9562L44.1204 47.5101C44.3054 47.7277 44.5447 47.8923 44.8141 47.9872C45.0835 48.0821 45.3732 48.1038 45.6537 48.0501L56.6808 45.9404C56.9578 45.8873 57.216 45.7626 57.4297 45.5787C57.6434 45.3948 57.8053 45.1581 57.8991 44.8922C57.9929 44.6263 58.0154 44.3405 57.9644 44.0631C57.9134 43.7858 57.7906 43.5267 57.6083 43.3116L50.3472 34.7322ZM48.1864 35.9547C48.4677 35.9004 48.7585 35.9219 49.0287 36.0171C49.299 36.1123 49.539 36.2777 49.7243 36.4963L56.3767 44.3547L46.274 46.2886C45.9935 46.3422 45.7038 46.3205 45.4345 46.2256C45.1651 46.1308 44.9257 45.9662 44.7407 45.7486L38.0778 37.9104L48.1864 35.9547ZM35.5236 40.692L43.3837 49.6603C43.5664 49.8685 43.7997 50.0263 44.061 50.1183C44.3224 50.2104 44.603 50.2336 44.8759 50.1858L56.6211 48.1219C56.6481 48.5155 56.53 48.9054 56.2891 49.2178C56.0482 49.5303 55.7012 49.7437 55.3136 49.8177L44.285 51.9269C44.0048 51.9803 43.7154 51.9585 43.4463 51.8638C43.1773 51.769 42.9381 51.6047 42.7532 51.3874L35.4799 42.8329C35.2243 42.5324 35.0876 42.1486 35.0957 41.7542C35.1037 41.3597 35.256 40.9819 35.5236 40.692ZM34.2084 44.4267L42.069 53.3935C42.2517 53.6017 42.485 53.7595 42.7463 53.8515C43.0076 53.9435 43.2883 53.9668 43.5612 53.919L55.3059 51.8566C55.3329 52.2502 55.2147 52.6401 54.9738 52.9525C54.7329 53.265 54.3859 53.4784 53.9984 53.5524L42.9697 55.6616C42.6895 55.715 42.4001 55.6933 42.1311 55.5985C41.862 55.5037 41.6228 55.3394 41.438 55.1222L34.1647 46.5676C33.9091 46.2671 33.7724 45.8833 33.7804 45.4889C33.7885 45.0944 33.9407 44.7166 34.2084 44.4267Z"
                    fill="white"
                  />
                </svg>
              </motion.div>
            </div>

            {/* Main Heading Section with Side Icons */}
            <div className="relative max-w-[1080px] mx-auto px-2 sm:px-4 md:px-20 mt-2 sm:mt-6 md:mt-8">
              {/* Left Side Icon - Hidden on mobile */}
              <motion.div
                animate={{
                  y: [0, 25, 0],
                  rotate: [0, -15, 0],
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute left-0 bottom-32 hidden md:block"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-12 h-12 md:w-[64px] md:h-[64px]"
                  viewBox="0 0 74 74"
                  fill="none"
                >
                  <rect
                    y="15.638"
                    width="60.4207"
                    height="60.4207"
                    rx="6.21896"
                    transform="rotate(-15 0 15.638)"
                    fill="#EE3F2F"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M36.6961 30.7126C35.1892 31.1164 33.9043 32.1023 33.1243 33.4534C32.3442 34.8045 32.1328 36.4101 32.5366 37.9171C32.9404 39.4241 33.9263 40.7089 35.2774 41.489C36.6285 42.269 38.2341 42.4804 39.7411 42.0766C41.2481 41.6728 42.5329 40.6869 43.313 39.3358C44.093 37.9847 44.3044 36.3791 43.9006 34.8721C43.4968 33.3651 42.511 32.0803 41.1598 31.3002C39.8087 30.5202 38.2031 30.3088 36.6961 30.7126ZM34.7565 37.3239C34.5106 36.4063 34.6393 35.4287 35.1143 34.6061C35.5892 33.7834 36.3715 33.1831 37.2891 32.9373C38.2066 32.6914 39.1842 32.8201 40.0069 33.2951C40.8295 33.7701 41.4298 34.5523 41.6756 35.4699C41.9215 36.3874 41.7928 37.3651 41.3178 38.1877C40.8429 39.0103 40.0606 39.6106 39.143 39.8565C38.2255 40.1023 37.2479 39.9736 36.4252 39.4987C35.6026 39.0237 35.0023 38.2414 34.7565 37.3239Z"
                    fill="white"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22.798 34.6717C22.6816 35.1065 22.6519 35.5599 22.7108 36.0062C22.7697 36.4524 22.9159 36.8827 23.1411 37.2724C23.3663 37.6622 23.6661 38.0037 24.0233 38.2775C24.3806 38.5514 24.7882 38.7522 25.2231 38.8684C25.4138 38.9194 25.5878 39.0198 25.7275 39.1594C25.8672 39.299 25.9676 39.4729 26.0187 39.6636C26.0698 39.8544 26.0698 40.0552 26.0186 40.2459C25.9675 40.4366 25.867 40.6105 25.7273 40.7501C25.409 41.0683 25.1565 41.446 24.9842 41.8618C24.8119 42.2776 24.7232 42.7233 24.7232 43.1733C24.7231 43.6234 24.8118 44.0691 24.984 44.4849C25.1562 44.9007 25.4087 45.2785 25.7269 45.5967L29.0156 48.8856C29.3338 49.2039 29.7116 49.4564 30.1274 49.6287C30.5431 49.801 30.9888 49.8897 31.4389 49.8897C31.8889 49.8898 32.3346 49.8011 32.7504 49.6289C33.1662 49.4567 33.544 49.2042 33.8623 48.886C34.0019 48.7463 34.1759 48.6458 34.3667 48.5946C34.5575 48.5435 34.7584 48.5434 34.9493 48.5944C35.1401 48.6455 35.3142 48.7458 35.4539 48.8854C35.5937 49.025 35.6943 49.1989 35.7456 49.3897C36.2355 51.218 38.1141 52.3026 39.9425 51.8127L44.4362 50.6086C46.2631 50.1191 47.3477 48.2405 46.8582 46.4137C46.8071 46.2229 46.8072 46.0221 46.8582 45.8314C46.9093 45.6407 47.0097 45.4667 47.1492 45.327C47.2887 45.1873 47.4625 45.0868 47.6532 45.0354C47.8439 44.9841 48.0447 44.9839 48.2355 45.0347C48.67 45.1513 49.1233 45.1811 49.5693 45.1225C50.0154 45.0639 50.4455 44.9179 50.8352 44.6931C51.2249 44.4682 51.5664 44.1687 51.8403 43.8118C52.1142 43.4549 52.3151 43.0475 52.4316 42.6129L53.6363 38.1185C53.8711 37.2407 53.7478 36.3057 53.2934 35.5189C52.839 34.7321 52.0907 34.158 51.2131 33.9228C51.0223 33.8716 50.8483 33.771 50.7086 33.6313C50.569 33.4916 50.4686 33.3176 50.4174 33.1268C50.3663 32.936 50.3663 32.7351 50.4174 32.5442C50.4684 32.3534 50.5688 32.1794 50.7085 32.0396C51.0268 31.7214 51.2793 31.3437 51.4516 30.9279C51.6238 30.5121 51.7125 30.0664 51.7126 29.6164C51.7126 29.1663 51.624 28.7206 51.4517 28.3048C51.2795 27.889 51.0271 27.5112 50.7088 27.193L47.4172 23.9049C46.7748 23.2628 45.9037 22.9021 44.9954 22.9022C44.0872 22.9022 43.2161 23.263 42.5739 23.9052C42.434 24.0446 42.26 24.1448 42.0692 24.1957C41.8784 24.2466 41.6776 24.2464 41.4869 24.1952C41.2962 24.144 41.1224 24.0435 40.9828 23.9039C40.8432 23.7642 40.7428 23.5903 40.6916 23.3996C40.2021 21.5728 38.3231 20.4867 36.4948 20.9766L32.001 22.1807C30.1727 22.6706 29.088 24.5492 29.5779 26.3775C29.6292 26.5684 29.6293 26.7695 29.5782 26.9604C29.5271 27.1514 29.4266 27.3255 29.2869 27.4654C29.1471 27.6052 28.973 27.7057 28.7821 27.7569C28.5912 27.8081 28.3901 27.8081 28.1992 27.7569C27.7644 27.6404 27.311 27.6107 26.8648 27.6695C26.4186 27.7282 25.9883 27.8743 25.5986 28.0993C25.2088 28.3244 24.8672 28.624 24.5933 28.9811C24.3193 29.3382 24.1184 29.7458 24.002 30.1805L22.798 34.6717ZM25.8186 36.646C25.6756 36.608 25.5415 36.5422 25.424 36.4522C25.3064 36.3623 25.2078 36.2501 25.1336 36.1221C25.0595 35.994 25.0113 35.8526 25.0119 35.7059C24.9725 35.5592 24.9821 35.4101 25.0204 35.2672L26.2259 30.7757C26.2641 30.6328 26.33 30.4988 26.42 30.3814C26.51 30.264 26.6223 30.1655 26.7504 30.0915C26.8785 30.0175 27.0199 30.0695 27.1666 29.9501C27.3132 29.9308 27.4623 29.9406 27.6051 29.9789C30.1542 30.6616 32.4847 28.33 31.8019 25.7816C31.6411 25.1816 31.9979 24.5635 32.598 24.4027L37.0917 23.1986C37.6918 23.0378 38.3084 23.3951 38.4692 23.9951C39.152 26.5435 42.3357 27.396 44.2008 25.5321C44.3052 25.4275 44.4291 25.3445 44.5656 25.2879C44.7021 25.2312 44.8484 25.2021 44.9961 25.202C45.1439 25.2019 45.2902 25.231 45.4267 25.2875C45.5633 25.344 45.6873 25.4269 45.7918 25.5314L49.0819 28.8199C49.5205 29.2598 49.521 29.9726 49.0815 30.4128C47.2153 32.2785 48.0689 35.464 50.6175 36.1452C51.2163 36.3055 51.5738 36.9227 51.4139 37.5229L50.2092 42.0174C50.171 42.1601 50.105 42.2939 50.015 42.4112C49.925 42.5284 49.8128 42.6267 49.6848 42.7005C49.5568 42.7743 49.4156 42.8222 49.269 42.8414C49.1225 42.8606 48.9737 42.8507 48.831 42.8123C46.2834 42.1292 43.9533 44.4623 44.6358 47.0092C44.7125 47.2972 44.6719 47.6039 44.5229 47.862C44.3738 48.1202 44.1285 48.3087 43.8407 48.3862L39.347 49.5903C39.0585 49.6676 38.7512 49.6271 38.4926 49.4778C38.234 49.3285 38.0453 49.0826 37.9681 48.7942C37.2852 46.2458 34.1001 45.3937 32.2353 47.2591C32.1308 47.3637 32.0066 47.4467 31.8699 47.5033C31.7332 47.5599 31.5868 47.589 31.4388 47.589C31.2909 47.5889 31.1444 47.5598 31.0078 47.5031C30.8712 47.4464 30.747 47.3634 30.6425 47.2587L27.3538 43.9698C27.143 43.7586 27.0247 43.4724 27.0249 43.174C27.025 42.8756 27.1436 42.5894 27.3546 42.3784C29.2193 40.5131 28.3658 37.3276 25.8182 36.6446"
                    fill="white"
                  />
                </svg>
              </motion.div>

              {/* Right Side Icon - Hidden on mobile */}
              <motion.div
                animate={{
                  y: [0, -25, 0],
                  rotate: [0, 15, 0],
                }}
                transition={{
                  duration: 8,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="absolute right-0 bottom-5 hidden md:block"
              >
                <svg
                  className="w-12 h-12 md:w-[64px] md:h-[64px]"
                  viewBox="0 0 69 69"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    y="14.4939"
                    width="56"
                    height="56"
                    rx="5"
                    transform="rotate(-15 0 14.4939)"
                    fill="#FF8176"
                  />
                  <path
                    d="M32.2942 23.4806C27.1541 24.8579 24.1034 30.142 25.4806 35.2821C25.9306 36.9613 26.7957 38.4154 27.9362 39.5663C28.0116 39.6422 28.071 39.7324 28.111 39.8316C28.151 39.9309 28.1708 40.037 28.1692 40.144L28.1045 44.367L31.7306 42.1982C31.8225 42.1434 31.9243 42.1074 32.0302 42.0924C32.1361 42.0775 32.244 42.0838 32.3474 42.1111C33.9655 42.5366 35.6667 42.5313 37.2821 42.0957C42.423 40.7182 45.473 35.4343 44.0957 30.2942C42.7184 25.1541 37.4351 22.1032 32.2942 23.4806ZM23.9294 35.6978C22.3225 29.7006 25.8814 23.5363 31.8786 21.9294C37.8757 20.3225 44.04 23.8814 45.647 29.8786C47.2539 35.8757 43.6949 42.04 37.6978 43.647C35.8611 44.1391 34.0059 44.1465 32.2711 43.7468L28.3101 46.115C28.126 46.2249 27.9159 46.2836 27.7014 46.2851C27.487 46.2866 27.2761 46.2309 27.0904 46.1236C26.9047 46.0163 26.7511 45.8615 26.6453 45.6749C26.5395 45.4884 26.4854 45.277 26.4886 45.0626L26.5592 40.449C25.3059 39.1052 24.4027 37.4734 23.9294 35.6978ZM29.5109 31.7083C29.4558 31.5025 29.4847 31.2834 29.5911 31.0989C29.6976 30.9145 29.873 30.7799 30.0787 30.7248L37.835 28.6465C38.0407 28.5914 38.2599 28.6203 38.4443 28.7267C38.6288 28.8332 38.7633 29.0086 38.8184 29.2143C38.8736 29.42 38.8447 29.6392 38.7382 29.8236C38.6317 30.0081 38.4564 30.1427 38.2507 30.1978L30.4944 32.2761C30.2887 32.3312 30.0695 32.3023 29.8851 32.1958C29.7006 32.0894 29.566 31.914 29.5109 31.7083ZM31.3257 35.3786C31.12 35.4337 30.9446 35.5683 30.8381 35.7527C30.7316 35.9371 30.7028 36.1563 30.7579 36.362C30.813 36.5677 30.9476 36.7431 31.132 36.8496C31.3165 36.9561 31.5356 36.9849 31.7413 36.9298L36.3951 35.6828C36.6008 35.6277 36.7762 35.4932 36.8827 35.3087C36.9892 35.1243 37.018 34.9051 36.9629 34.6994C36.9078 34.4937 36.7732 34.3183 36.5888 34.2118C36.4043 34.1053 36.1852 34.0765 35.9795 34.1316L31.3257 35.3786Z"
                    fill="white"
                  />
                </svg>
              </motion.div>

              {/* Main Heading */}
              <motion.h1
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: {
                    opacity: 1,
                    y: 0,
                    transition: { duration: 2, ease: "easeOut" },
                  },
                }}
                className="max-w-[1009px] mx-auto text-[32px] sm:text-[52px] md:text-[64px] lg:text-[80px] font-bold leading-[1.08] mb-4 sm:mb-8 drop-shadow-sm"
              >
                <motion.span>
                  <span className="text-white">Supercharge </span>
                </motion.span>
                <motion.span
                  animate={{
                    color: ["#000000", "#FFA2A2", "#000000"],
                    textShadow: [
                      "0px 0px 0px rgba(255,162,162,0)",
                      "0px 0px 25px rgba(255,162,162,0.1)",
                      "0px 0px 0px rgba(255,162,162,0)",
                    ],
                  }}
                  transition={{
                    duration: 8,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className="block sm:inline"
                >
                  Your Customer Conversations on
                </motion.span>
                <span className="text-white block sm:inline"> WhatsApp</span>
              </motion.h1>

              {/* Description */}
              <motion.p
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                className="max-w-[800px] mx-auto text-white/90 text-sm sm:text-lg md:text-xl mb-4 sm:mb-12 leading-relaxed px-2"
              >
                Pingly is the Customer Conversations WhatsApp platform that helps businesses
                automate conversations, engage customers, and drive sales — all
                within WhatsApp.
              </motion.p>
            </div>
          </motion.div>

          {/* Dashboard Preview Mockups */}
          <motion.div
            initial={{ opacity: 0, y: 60, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            transition={{
              duration: 1,
              delay: 0.2,
              type: "spring",
              bounce: 0.3,
            }}
            className="mt-6 sm:mt-20 md:mt-24 w-full max-w-[420px] sm:max-w-[560px] md:max-w-[1020px] lg:max-w-[1320px] relative flex justify-center"
          >
            {/* Mobile version: Straight layout */}
            <div className="md:hidden w-full max-w-md mx-auto">
              <div className="bg-white rounded-2xl shadow-2xl p-2 border-4 border-white/30 backdrop-blur-sm">
                <div className="bg-[#FFF8F0] rounded-xl overflow-hidden h-[360px] flex flex-col">
                  {/* Chat Header */}
                  <div className="p-3 border-b border-orange-100 bg-white/50 backdrop-blur-sm flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <div className="w-8 h-8 rounded-full bg-orange-400 text-white flex items-center justify-center text-sm font-bold">
                        SE
                      </div>
                      <div className="text-left">
                        <div className="font-bold text-slate-800 text-sm">Stark Edge</div>
                        <div className="text-[10px] text-green-500 font-bold flex items-center gap-1">
                          ● Online
                        </div>
                      </div>
                    </div>
                    <div className="w-6 h-6 rounded-full border border-orange-200 flex items-center justify-center text-orange-400 text-sm">
                      ⋮
                    </div>
                  </div>

                  {/* Chat Messages with Scrollbar */}
                  <div className="flex-1 p-3 space-y-3 overflow-y-auto">
                    <div className="self-start max-w-[80%]">
                      <div className="bg-white p-3 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-xs border border-orange-50 leading-relaxed text-left">
                        Hi Ravi, What&apos;s up? Please check your schedule.
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 text-left ml-2">
                        12:44 PM
                      </div>
                    </div>

                    <div className="flex flex-col items-end">
                      <div className="bg-[#E86C3E] text-white p-3 rounded-2xl rounded-tr-none shadow-lg shadow-orange-200/50 max-w-[80%] text-xs leading-relaxed text-left">
                        Oh, hello! All perfectly. I will check it and get back to you soon 👍
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                        12:47 PM <span className="text-orange-500">✓✓</span>
                      </div>
                    </div>

                    <div className="self-start max-w-[80%]">
                      <div className="bg-white p-3 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-xs border border-orange-50 leading-relaxed text-left">
                        I have updated few changes over there.
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 text-left ml-2">
                        12:50 PM
                      </div>
                    </div>

                    <div className="flex flex-col items-end">
                      <div className="bg-[#E86C3E] text-white p-3 rounded-2xl rounded-tr-none shadow-lg shadow-orange-200/50 max-w-[80%] text-xs leading-relaxed text-left">
                        Alright so cool let me see it. Thanks 👍
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                        12:59 PM <span className="text-orange-500">✓✓</span>
                      </div>
                    </div>

                    <div className="self-start max-w-[80%]">
                      <div className="bg-white p-3 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-xs border border-orange-50 leading-relaxed text-left">
                        Let me know if you need any further assistance with the changes.
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 text-left ml-2">
                        1:05 PM
                      </div>
                    </div>

                    <div className="flex flex-col items-end">
                      <div className="bg-[#E86C3E] text-white p-3 rounded-2xl rounded-tr-none shadow-lg shadow-orange-200/50 max-w-[80%] text-xs leading-relaxed text-left">
                        Sure, I&apos;ll review everything and get back to you by tomorrow.
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                        1:10 PM <span className="text-orange-500">✓✓</span>
                      </div>
                    </div>

                    <div className="self-start max-w-[80%]">
                      <div className="bg-white p-3 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-xs border border-orange-50 leading-relaxed text-left">
                        Perfect! Also don&apos;t forget about the meeting scheduled for Friday at 3 PM.
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 text-left ml-2">
                        1:15 PM
                      </div>
                    </div>

                    <div className="flex flex-col items-end">
                      <div className="bg-[#E86C3E] text-white p-3 rounded-2xl rounded-tr-none shadow-lg shadow-orange-200/50 max-w-[80%] text-xs leading-relaxed text-left">
                        Yes, I have it marked on my calendar. Looking forward to it!
                      </div>
                      <div className="text-[9px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                        1:20 PM <span className="text-orange-500">✓✓</span>
                      </div>
                    </div>
                  </div>

                  {/* Message Input */}
                  <div className="p-3">
                    <div className="bg-white rounded-xl shadow-sm border border-orange-100 flex items-center p-2 gap-2">
                      <div className="w-6 h-6 flex items-center justify-center text-slate-300 text-sm">
                        ☺
                      </div>
                      <div className="flex-1 text-slate-300 text-xs text-left">
                        Type a message...
                      </div>
                      <div className="w-8 h-8 bg-[#FF8C42] rounded-lg flex items-center justify-center text-white shadow-md text-sm">
                        ➤
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Desktop version with floating cards */}
            <motion.div
              initial={{ rotateX: 0, rotateY: 0, rotateZ: 0 }}
              animate={{ rotateX: 0, rotateY: 0, rotateZ: 0 }}
              transition={{ duration: 1.5, ease: "easeOut" }}
              style={{ transformStyle: "preserve-3d" }}
              className="relative hidden md:block w-full max-w-[1050px] lg:max-w-[1180px] mx-auto"
            >
              <motion.div
                transition={{ type: "spring", stiffness: 100, damping: 20 }}
                className="bg-white rounded-[2rem] p-2 md:p-4 border-[6px] border-white/30 backdrop-blur-sm w-full mb-8 md:mb-0 -rotate-[8deg]"
              >
                {/* Interface */}
                <div className="bg-[#FFF8F0] rounded-[1.5rem] overflow-hidden h-[350px] md:h-[550px] flex">
                  {/* Sidebar */}
                  <div className="w-16 md:w-64 bg-white border-r border-orange-50/50 p-4 hidden md:flex flex-col gap-6">
                    {/* Top Icons */}
                    <div className="flex items-center gap-3 mb-2">
                      <div className="w-10 h-10 bg-orange-500 rounded-full text-white flex items-center justify-center">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z" />
                        </svg>
                      </div>
                      <div className="w-10 h-10 bg-orange-500 rounded-full text-white flex items-center justify-center">
                        <svg
                          className="w-5 h-5"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className="space-y-2">
                      {[
                        "Home",
                        "Team Inbox",
                        "Broadcast",
                        "Manage Templates",
                        "Automation",
                        "Contact",
                      ].map((item, i) => (
                        <div
                          key={i}
                          className={`flex items-center gap-3 p-3 rounded-xl cursor-pointer transition-colors ${i === 1 ? "bg-orange-50 text-orange-600 font-bold shadow-sm" : "text-slate-500 hover:bg-slate-50"}`}
                        >
                          <div
                            className={`w-6 h-6 rounded-lg ${i === 1 ? "bg-orange-200" : "bg-slate-100"}`}
                          ></div>
                          <span className="hidden lg:inline">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Chat List */}
                  <div className="w-80 bg-white border-r border-orange-50/50 p-4 hidden lg:block">
                    <div className="mb-6 relative">
                      <input
                        type="text"
                        placeholder="Search..."
                        className="w-full bg-slate-50 p-3 pl-10 rounded-xl text-slate-600 outline-none focus:ring-2 focus:ring-orange-200 transition-all"
                        readOnly
                      />
                      <svg
                        className="w-4 h-4 text-slate-400 absolute left-3 top-3.5"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </div>
                    <div className="space-y-4">
                      {[
                        { name: "Martian", initials: "M", color: "bg-indigo-400", message: "Hey" },
                        { name: "Robert", initials: "R", color: "bg-green-400", message: "Good Morning" },
                        { name: "Smith", initials: "S", color: "bg-orange-400", message: "Hey" },
                        { name: "John Doe", initials: "J", color: "bg-blue-400", message: "Hey", highlighted: true },
                        { name: "Martian", initials: "M", color: "bg-indigo-400", message: "Hey" },
                        { name: "Robert", initials: "R", color: "bg-green-400", message: "Good Morning" },
                      ].map((contact, i) => (
                        <div
                          key={i}
                          className={`flex items-center gap-4 p-3 rounded-xl cursor-pointer transition-all ${contact.highlighted ? "bg-[#FFF8F0] border border-orange-100 shadow-sm scale-[1.02]" : "hover:bg-slate-50"}`}
                        >
                          <div
                            className={`w-12 h-12 rounded-full flex-shrink-0 flex items-center justify-center text-lg font-bold text-white ${contact.color}`}
                          >
                            {contact.initials}
                          </div>
                          <div className="flex-1 overflow-hidden text-left">
                            <div className="flex justify-between items-center mb-1">
                              <div className="font-bold text-slate-800 text-sm">
                                {contact.name}
                              </div>
                              <div className="text-[10px] text-slate-400 font-medium">
                                12:30 PM
                              </div>
                            </div>
                            <div className="text-xs text-slate-500 truncate font-medium">
                              {contact.message}
                            </div>
                          </div>
                          {contact.highlighted && (
                            <div className="w-5 h-5 bg-orange-500 rounded-full text-[10px] text-white flex items-center justify-center">
                              2
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                  {/* Chat Area */}
                  <div className="flex-1 flex flex-col bg-[#FFF8F0] relative">
                    <div className="p-4 border-b border-orange-100 bg-white/50 backdrop-blur-sm flex justify-between items-center sticky top-0 z-10">
                      <div className="flex items-center gap-3">
                        <div className="w-10 h-10 rounded-full bg-orange-400 text-white flex items-center justify-center font-bold">
                          SE
                        </div>
                        <div className="text-left">
                          <div className="font-bold text-slate-800">
                            Stark Edge
                          </div>
                          <div className="text-xs text-green-500 font-bold flex items-center gap-1">
                            ● Online
                          </div>
                        </div>
                      </div>
                      <div className="w-8 h-8 rounded-full border border-orange-200 flex items-center justify-center text-orange-400">
                        ⋮
                      </div>
                    </div>
                    <div className="flex-1 p-6 space-y-6 overflow-y-auto">
                      <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 1.5 }}
                        className="self-start max-w-sm"
                      >
                        <div className="bg-white p-4 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-sm border border-orange-50 leading-relaxed text-left">
                          Hi Ravi, What&apos;s up? Please check your schedule.
                        </div>
                        <div className="text-[10px] text-slate-400 mt-1 text-left ml-2">
                          12:44 PM
                        </div>
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 1.5 }}
                        className="self-start max-w-sm w-full"
                      >
                        <div className="bg-[#FFF0E6] p-4 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-sm border border-orange-50 leading-relaxed text-left">
                          Hi Anni, What&apos;s Up? Please check your schedule
                        </div>
                        <div className="text-[10px] text-slate-400 mt-1 text-left ml-2">
                          12:44 PM
                        </div>
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 2.5 }}
                        className="flex flex-col items-end w-full"
                      >
                        <div className="bg-[#E86C3E] text-white p-4 rounded-2xl rounded-tr-none shadow-xl shadow-orange-200/50 max-w-sm text-sm leading-relaxed text-left">
                          Oh, hello! All perfectly.
                          <br />I will check it and get back to you soon 👍👍
                        </div>
                        <div className="text-[10px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                          12:47 PM <span className="text-orange-500">✓✓</span>
                        </div>
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 3.5 }}
                        className="self-start max-w-sm mt-2 w-full"
                      >
                        <div className="bg-[#FFF0E6] p-4 rounded-2xl rounded-tl-none shadow-sm text-slate-600 text-sm border border-orange-50 text-left">
                          I have updated few changes over there.
                        </div>
                        <div className="text-[10px] text-slate-400 mt-1 text-left ml-2">
                          12:50 PM
                        </div>
                      </motion.div>
                      <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 4 }}
                        className="flex flex-col items-end w-full"
                      >
                        <div className="bg-[#E86C3E] text-white p-4 rounded-2xl rounded-tr-none shadow-xl shadow-orange-200/50 max-w-sm text-sm leading-relaxed text-left">
                          Alright so cool let me see it. Thanks 👍
                        </div>
                        <div className="text-[10px] text-slate-400 mt-1 mr-2 flex items-center gap-1">
                          12:59 PM <span className="text-orange-500">✓✓</span>
                        </div>
                      </motion.div>
                    </div>
                    <div className="p-4 m-4">
                      <div className="bg-white rounded-2xl shadow-sm border border-orange-100 flex items-center p-2 gap-2">
                        <div className="w-8 h-8 flex items-center justify-center text-slate-300">
                          ☺
                        </div>
                        <div className="flex-1 text-slate-300 text-sm text-left">
                          Type a message...
                        </div>
                        <div className="w-10 h-10 bg-[#FF8C42] rounded-xl flex items-center justify-center text-white shadow-md">
                          ➤
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* Floating Top Right Card - Contacts - Desktop only */}
              <motion.div
                initial={{ x: 50, opacity: 1 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 5,
                  ease: "easeOut",
                }}
                className="absolute bottom-[160px] -left-[92px] md:top-[2%] md:-left-[96px] lg:-left-[128px] z-50 w-[180px] sm:w-[220px] md:w-auto hidden md:flex justify-center"
              >
                <div className="relative overflow-hidden rounded-3xl">
                  <div className="absolute top-4 left-4 md:top-8 md:left-6">
                    <svg
                      width="40"
                      height="40"
                      className="md:w-14 md:h-14"
                      viewBox="0 0 64 64"
                      fill="none"
                    />
                  </div>
                  <img
                    src={contacts}
                    alt="contacts"
                    className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-none"
                  />
                </div>
              </motion.div>

              {/* Floating Bottom Left Card - Martian Chat - Desktop only */}
              <motion.div
                initial={{ x: 50, opacity: 1 }}
                animate={{ x: 0, opacity: 1 }}
                transition={{
                  duration: 5,
                  ease: "easeOut",
                }}
                className="absolute top-[200px] -left-[84px] md:top-auto md:bottom-[2%] md:-left-[120px] lg:-left-[128px] z-50 w-[180px] sm:w-[220px] md:w-auto hidden md:flex justify-center"
              >
                <div className="relative overflow-hidden rounded-3xl">
                  <div className="absolute top-4 left-4 md:top-8 md:left-6">
                    <svg
                      width="48"
                      height="48"
                      className="md:w-16 md:h-16"
                      viewBox="0 0 76 76"
                      fill="none"
                    />
                  </div>
                  <img
                    src={martianChat}
                    alt="martianChat"
                    className="w-full max-w-[280px] sm:max-w-[320px] md:max-w-none"
                  />
                </div>
              </motion.div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Hero;